import React from "react";
import { motion } from "framer-motion";

const BusinessChangeSection: React.FC = () => {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-8 md:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-6 md:mb-8">
            What Will Change In Your Business?
          </h2>
          <div className="w-24 h-1 bg-red-500 mx-auto"></div>
        </motion.div>

        {/* Circle in First Row */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="flex justify-center mb-8 md:mb-12"
        >
          <div className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 bg-red-600 rounded-full border-2 border-white flex items-center justify-center shadow-2xl">
            <h3 className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-center px-4 sm:px-6">
              ✨ Salon Growth Break through  ✨ 
            </h3>
          </div>
        </motion.div>

        {/* 4 Content Boxes in Second Row */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {/* Box 1 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-gray-100 rounded-lg p-4 md:p-6 shadow-lg border-2 border-dashed border-gray-300"
            >
              <h4 className="text-black text-base md:text-lg font-bold mb-2 md:mb-3">
                Better Customer Data Management
              </h4>
              <p className="text-black text-xs md:text-sm">
                Keep track of client history, preferences & visits easily.
              </p>
            </motion.div>

            {/* Box 2 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-gray-100 rounded-lg p-4 md:p-6 shadow-lg border-2 border-dashed border-gray-300"
            >
              <h4 className="text-black text-base md:text-lg font-bold mb-2 md:mb-3">
                Streamlined Operations
              </h4>
              <p className="text-black text-xs md:text-sm">
                Automate bookings, billing & staff schedules.
              </p>
            </motion.div>

            {/* Box 3 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
              className="bg-gray-100 rounded-lg p-4 md:p-6 shadow-lg border-2 border-dashed border-gray-300"
            >
              <h4 className="text-black text-base md:text-lg font-bold mb-2 md:mb-3">
                Business Growth Insights
              </h4>
              <p className="text-black text-xs md:text-sm">
                Smart analytics & reports to grow revenue.
              </p>
            </motion.div>

            {/* Box 4 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              viewport={{ once: true }}
              className="bg-gray-100 rounded-lg p-4 md:p-6 shadow-lg border-2 border-dashed border-gray-300"
            >
              <h4 className="text-black text-base md:text-lg font-bold mb-2 md:mb-3">
               Customer Retention with up to 40% Business growth
              </h4>
              <p className="text-black text-xs md:text-sm">
                Build lasting relationships & increase repeat visits for sustainable growth
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessChangeSection;
